import {
  SET_PATHNAME,
  SET_COMPLETEDSTAGES,
  SET_CURRENTSTAGE,
} from "../actions/pathNameActions";

const initialState: any = {
  pathname: "",
  completedstages: [],
  currentstage: "",
};

const dataReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_PATHNAME:
      state = { ...state };
      state.pathname = action.payload;

      return state;

    case SET_COMPLETEDSTAGES:
      state = { ...state };
      state.completedstages = action.payload;

      return state;
    case SET_CURRENTSTAGE:
      state = { ...state };
      state.currentstage = action.payload;

      return state;

    default:
      return state;
  }
};

export default dataReducer;
